import {useNavigate} from "react-router-dom";
import Noprofile from "../../../images/profileImage.png";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {proposalDate} from "../../../utils/date";
import ImageComponent from "../../components/shared/ImageComponent";
import {replace} from "formik";

import {getNotificationInterventionIdentifier} from "../../../utils/interventionUrl";
import helpClicLogo from "../../../images/mini-logo.png";
const NotificationItem = ({notification}) => {
  const navigate = useNavigate();

  const navigateToChat = () => {
    if (notification?.notifiableType === "offer") {
      navigate(`/annonce/${notification?.notifiableId}`);
    } else if (notification?.notifiableType === "intervention") {
      navigate(`/intervention/${getNotificationInterventionIdentifier(notification)}`, {replace: false});
    } else if (["ticket", "ticketMessage"].includes(notification?.notifiableType)) {
      navigate(`/reclamation/${notification?.ticketId || notification?.notifiableId}`, {replace: false});
    } else if (notification?.chatroomId) {
      navigate(`/messages#${notification.chatroomId}`, {replace: false});
    } else if (
      !notification?.chatroomId &&
      notification?.notifiableType === "proposition"
    ) {
      navigate(`/intervention/${getNotificationInterventionIdentifier(notification)}`, {replace: false});
    }
    return;
  };
  return (
    <li className="cursor-pointer" onClick={navigateToChat}>
      <div className="timeline-panel">
        <div className="media mr-2">
          <ImageComponent
            alt={"avatar"}
            className={"!rounded-full !object-cover aspect-square"}
            src={
              ["ADMIN", "SUPPORT"].includes(notification?.sender?.selectedRole)
                ? helpClicLogo
                : buildImageUrl(notification?.sender?.imageUri)
            }
            fallback={<img alt="" className="!rounded-full" src={Noprofile} />}
          />
        </div>
        <div className="media-body">
          <h6 className="mb-1 !text-sm">{notification?.message}</h6>
          <small className="d-block">
            {" "}
            {proposalDate(notification?.createdAt)}
          </small>
        </div>
      </div>
    </li>
  );
};

export default NotificationItem;
